import "./PublicAssignment.styles.scss";
import React, { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useFetchPublicAssignment } from "utils/hooks";
import { PageLoading, BottomModal } from "components";
import PublicAssignmentBody from "./components/PublicAssignmentBody";
import {
  AssignmentDispatchContext,
  AssignmentStateContext,
  useAssignmentStoreDefaults,
} from "pages/AppPages/PatientPages/AssignmentsForPatients/assignmentStore";

const PublicAssignment = () => {
  const dataRef = useRef(false);
  const navigate = useNavigate();
  const { assignmentState, setAssignmentState } = useAssignmentStoreDefaults();
  const { linkSlug } = useParams();
  const { fetchPublicAssignmInfo, publicAssignmInfo, loading } =
    useFetchPublicAssignment({ linkSlug });

  useEffect(() => {
    if (dataRef.current) return;
    fetchPublicAssignmInfo();
    dataRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (publicAssignmInfo?.assignment && !assignmentState.initialized)
      setAssignmentState({
        assignments: [publicAssignmInfo.assignment],
        submissions: [],
      });
  });

  if (loading) return <PageLoading />;

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      {assignmentState.initialized && publicAssignmInfo?.assignment && (
        <BottomModal
          isVisible={true}
          title={publicAssignmInfo?.assignment?.label}
          extraClass="public_body_color"
          fullScreen={true}
          handleClose={() => navigate(-1)}
        >
          <AssignmentStateContext.Provider value={assignmentState}>
            <AssignmentDispatchContext.Provider value={setAssignmentState}>
              <PublicAssignmentBody
                publicAssignmInfo={publicAssignmInfo}
                visible={publicAssignmInfo.visibleToPatient}
              />
            </AssignmentDispatchContext.Provider>
          </AssignmentStateContext.Provider>
        </BottomModal>
      )}
    </>
  );
};

export default PublicAssignment;
